import React from 'react';

// Composant RoomDetails affichant des informations sur une pièce
const RoomDetails = ({ roomName, description }) => {
    return (
        <div style={{
            position: 'absolute',
            top: '20px',
            left: '20px',
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            padding: '10px',
            borderRadius: '8px'
        }}>
            <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>{roomName}</h1>
            <p style={{ fontSize: '16px' }}>{description}</p>
        </div>
    );
};

export default RoomDetails;
